'use client';
import styled from 'styled-components';

const LocationItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 24px;
  min-height: 56px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey100};
  }

  & > div {
    width: 100%;
  }
`;

export default LocationItem;
